<template>
  <div>
    <div class="rotator-wrapper" :class="{ hidden: hideTimeline }">
      <v-btn
        icon
        elevation="0"
        @click="swiperInstance.slidePrev()"
        :style="{ visibility: visibleControls ? 'visible' : 'hidden' }"
      >
        <v-icon size="14">$chevron_left</v-icon>
      </v-btn>
      <swiper ref="instance" class="rotator" :options="swiperOption">
        <swiper-slide v-for="slide in processedSlides" :key="slide.id">
          <Slide
            :slide="slide"
            :value="value"
            :display-value="displayValue"
            @input="$emit('input', $event)"
          />
        </swiper-slide>
      </swiper>
      <v-btn
        icon
        elevation="0"
        @click="swiperInstance.slideNext()"
        :style="{ visibility: visibleControls ? 'visible' : 'hidden' }"
      >
        <v-icon size="14">$chevron_right</v-icon>
      </v-btn>
    </div>
  </div>
</template>

<script>
import Slide from "./TimelineRotator/Slide";
export default {
  name: "TimelineRotator",
  components: { Slide },
  props: {
    slides: Array,
    value: Number,
    hideTimeline: Boolean,
    displayValue: Number
  },
  mounted() {
    this.swiperInstance = this.$refs.instance.swiperInstance;
    this.processSlides();

    this.$root.$on("slideToEvent", event_id => {
      let slideTo = this["processedSlides"].findIndex(t => t.id == event_id);
      if (slideTo != -1) this.swiperInstance.slideTo(slideTo);
    });
  },
  methods: {
    async processSlides() {
      let sliderName = "processedSlides";
      let slideTo = -1;

      const { event_id } = this.$route.query;
      if (event_id) {
        slideTo = this[sliderName].findIndex(t => t.id == event_id && t.posted);
      }

      if (slideTo == -1) {
        slideTo = this[sliderName].findIndex(
          t => t.initial_timeline_event && t.posted
        );
      }

      if (slideTo == -1) {
        slideTo = this[sliderName].findIndex(
          t => t.status == "just_posted" && t.posted
        );
      }

      if (slideTo == -1) {
        sliderName = "slides";

        if (event_id) {
          slideTo = this[sliderName].findIndex(
            t => t.id == event_id && t.posted
          );
        }
        if (slideTo == -1) {
          slideTo = this[sliderName].findIndex(
            t => t.initial_timeline_event && t.posted
          );
        }
        if (slideTo == -1) {
          slideTo = this[sliderName].findIndex(
            t => t.status == "just_posted" && t.posted
          );
        }
        if (slideTo == -1) {
          slideTo = this[sliderName].findIndex(t => t.posted);
        }
      }

      if (slideTo != -1) {
        this.$emit("input", this[sliderName][slideTo]?.id);
        this.swiperInstance.slideTo(slideTo);
      } else {
        const index = this[sliderName].length - 1;
        const lastSlide = this[sliderName][index];
        if (lastSlide?.posted) {
          this.$emit("input", lastSlide?.id);
          this.swiperInstance.slideTo(index);
        }
      }
    }
  },
  computed: {
    processedSlides() {
      return this.slides.filter(s => !s.hidden);
    },
    swiperOption() {
      return {
        speed: 400,
        keyboard: {
          enabled: true
        },
        breakpoints: {
          0: {
            slidesPerView: 1.83,
            spaceBetween: 20
          },
          960: {
            slidesPerView: 3,
            spaceBetween: 20
          },
          1264: {
            slidesPerView: 6,
            spaceBetween: 20
          }
        }
      };
    },
    visibleControls() {
      const conditions = [
        this.$size == "sm" && this.slides.length > 2,
        this.$size == "md" && this.slides.length > 3,
        (this.$size == "lg" || this.$size == "xl") && this.slides.length > 4
      ];
      return conditions.find(t => t);
    }
  },
  watch: {
    value(value) {
      const event = this.slides.find(s => s.id == value);
      if (event) {
        this.$root.$emit("setActiveEvent", { ...event });
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout);
  }
};
</script>

<style lang="scss" scoped>
.rotator-wrapper::v-deep .rotator {
  padding: 45px 0 !important;
  flex: 1;
}
.rotator-wrapper.hidden {
  display: none;
}

.swiper-slide {
  height: auto;
  .rotator-slide__wrapper {
    height: 100%;
    box-sizing: border-box;
  }
}

@media screen and (max-width: 960px) {
  .rotator-wrapper::v-deep .rotator {
    margin: 0 -20px;
  }

  .swiper-container {
    overflow: visible;
  }
}
</style>
